import { useNavigate } from 'react-router-dom'

import { Box, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

interface Props {
  policyId: number
  issueCount: number
}

const PayrollIssuesPill = ({ policyId, issueCount }: Props) => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()

  if (!issueCount) {
    return null
  }

  const issuesPillMessage = i18n.tp('payroll_bundle.payroll_issues.review_issues', {
    count: issueCount,
  })

  return (
    <Box
      background="radicalRed1000"
      padding="s8"
      borderRadius={{ all: 'abs008' }}
      height="s24"
      justifyContent="center"
      onClick={() => {
        navigate(
          navigation.payrollBundle.policy.issues.fullPath({
            policyId,
          })
        )

        track(trackingEvents.payroll.userClicksOnReviewPayrollIssues, {
          policy_id: policyId,
          number_of_issues: issueCount,
        })
      }}
      cursor="pointer"
    >
      <Text.Normal color="grey000White" weight="medium" size="200">
        {issuesPillMessage}
      </Text.Normal>
    </Box>
  )
}

export default observer(PayrollIssuesPill)
